import React from "react";

export default function BsCardText() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)" fill="#currentColor">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M3 18.75C3 18.3358 3.33579 18 3.75 18H14.25C14.6642 18 15 18.3358 15 18.75C15 19.1642 14.6642 19.5 14.25 19.5H3.75C3.33579 19.5 3 19.1642 3 18.75Z" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M3 14.25C3 13.8358 3.33579 13.5 3.75 13.5H20.25C20.6642 13.5 21 13.8358 21 14.25C21 14.6642 20.6642 15 20.25 15H3.75C3.33579 15 3 14.6642 3 14.25Z" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M3 9.75C3 9.33579 3.33579 9 3.75 9H20.25C20.6642 9 21 9.33579 21 9.75C21 10.1642 20.6642 10.5 20.25 10.5H3.75C3.33579 10.5 3 10.1642 3 9.75Z" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M3 5.25C3 4.83579 3.33579 4.5 3.75 4.5H20.25C20.6642 4.5 21 4.83579 21 5.25C21 5.66421 20.6642 6 20.25 6H3.75C3.33579 6 3 5.66421 3 5.25Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(0 .082)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
